import {CanActivateFn, Router} from '@angular/router';
import {inject} from "@angular/core";
import {MsalService} from "@azure/msal-angular";
import {CandidateProfileService} from "../service/candidate-profile.service";
import {catchError, EMPTY, map} from "rxjs";
import {ErrorDTO} from "../dto/error-dto";

export const authGuard: CanActivateFn = (route, state) => {
  const msalService = inject(MsalService);
  const router = inject(Router);
  const candidateProfileService = inject(CandidateProfileService);

  let activeAccount = msalService.instance.getActiveAccount();

  if (!activeAccount && msalService.instance.getAllAccounts().length > 0) {
    let accounts = msalService.instance.getAllAccounts();
    msalService.instance.setActiveAccount(accounts[0]);
    activeAccount = accounts[0];
  }

  if (activeAccount && route.queryParams && route.queryParamMap.get('key') && route.queryParamMap.get('hash')) {
    let key = route.queryParamMap.get('key');
    let hash = route.queryParamMap.get('hash');
    let reference = route.queryParamMap.get('reference');
    return getCandidateProfile(key, hash, reference)
  }

  router.navigate(['/error'])
  return false;

  function getCandidateProfile(key: string, hash: string, reference: string) {
    return candidateProfileService.getCandidateProfile(key, hash, reference).pipe(
      map((candidateProfile) => {
        candidateProfileService.candidateProfile = candidateProfile;
        return true;
      }), catchError((error, caught) => {
        if (error.status == 401) {
          candidateProfileService.isUnauthorized.next(true);
          localStorage.setItem("cp-key", key);
          localStorage.setItem("cp-hash", hash);
        }
        let errorDto = <ErrorDTO>error.error;
        router.navigate(['/error'], { state: errorDto })
        return EMPTY;
      })
    );
  }
};
